export const FETCH_STUDENT_DATA = 'FETCH_STUDENT_DATA';
export const CREATE_STUDENT = 'CREATE_STUDENT';
export const UPDATE_STUDENT_TYPE = 'UPDATE_STUDENT_TYPE';
